module.exports = __webpack_public_path__ + "img/republika-slovenija.e256ba2d.webp";